class BlockPayBenefits{
	constructor(blockEl) {
		this.blockEl = blockEl;
		
		this.setupEventHandlers();
		
	}
	
	setupEventHandlers() {
		const accordionTabs = this.blockEl.querySelectorAll('.block-pay-benefits__tab, .block-pay-benefits__mobile-tab-title');
        const accordionContent = this.blockEl.querySelectorAll('.block-pay-benefits__accordion-content');
        // const mobileTabs = this.blockEl.querySelectorAll('.block-pay-benefits_mobile-tab-title');


		accordionTabs.forEach((i, index) => {

            if(index === 0) {
                i.classList.add('active');
                const target = i.getAttribute('data-target');
                const initialContentEl = document.getElementById(target);
                initialContentEl.classList.add('active');
            }

			i.addEventListener('click', (event) => {
                const clickedElement = event.target;
                const targetID = clickedElement.getAttribute('data-target');
                const contentElement = document.getElementById(targetID);
                const clickedTab = document.querySelector('[data-target="' + targetID + '"]');

                accordionTabs.forEach(t => {
                    t.classList.remove('active');
                })

                accordionContent.forEach(e => {
                    e.classList.remove('active');
                })

                clickedTab.classList.add('active');
                contentElement.classList.add('active');
			});
		})
	}
}

export default BlockPayBenefits;